import { create } from "zustand";
import { SettingHistoryProps } from "./interface/setting-history.interface";
import { getDistinctSettingHistoryColumns, getSettingHistory } from "src/services/settings.service";
import { FilterDistinctSettingHistory, SettingHistoryFilters } from "src/entity/settings/setting-history";
import { convertGetParamsArrayToString } from "src/utils/array";

export const settingHistoryStore = create<SettingHistoryProps>((set) => ({
  data: [],
  total: 0,
  loading: false,
  error: null,
  dataDistinct: null,

  getDistinctSettingHistoryColumns: async (query: FilterDistinctSettingHistory) => {
    try {
      const response = await getDistinctSettingHistoryColumns(query);

      set(() => ({
        dataDistinct: response.data,
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getSettingHistory: async (params: SettingHistoryFilters) => {
    set(() => ({ loading: true }));
    try {
      const response = await getSettingHistory(convertGetParamsArrayToString(params));

      set(() => ({
        data: response.data?.data || [],
        total: response.data.total,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      set(() => ({ loading: false }));
    }
  },
}));
